
export default {
    attribute: {
        backgroundColor: '',
        borderColor: '',
        borderSize: 0,
        borderRadius: 0,
        postition: 'all',
        postitionX: 0,
        postitionY: 0,
        cptIndex: 1000000,
    },
}